import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// components (global)
import { CustomTabs } from "components/Tabs";

// material-ui
import { Close as CloseIcon } from "@material-ui/icons";
import { Button, Divider, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// stores
import { closeDrawer } from "stores/main/MainActions";
import {
  toggleEditPropertyDialogOpen,
  toggleEditResidentDialogOpen,
} from "stores/card/CardAction";
import PropertyInfoDetail from "./PropertyInfoDetails";

// styles
const useStyles = makeStyles((theme) => ({
  root: {},
  header: {
    paddingBottom: theme.spacing(1),
    flexShrink: 0,
    display: "flex",
  },
  content: { paddingTop: theme.spacing(1) },
  tabContent: { padding: theme.spacing(2) },
  listOdd: { backgroundColor: "#f9f9f9" },
  listTitle: { width: theme.spacing(5) },
}));

const PropertyInfo = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  // selector
  const vendorId = useSelector((state) => state.main.toggleDrawer.parameterId);
  const vendor = useSelector((state) => {
    return state.firestore.data.all_vendors
      ? state.firestore.data.all_vendors[vendorId]
      : null;
  });

  // state
  const [tabs] = useState([
    {
      value: "details",
      label: "Details",
      content: <PropertyInfoDetail />,
    },
  ]);

  // functions
  const onClose = () => {
    dispatch(closeDrawer());
  };

  const handleEditProperty = () => {
    dispatch(toggleEditPropertyDialogOpen({ open: true, id: vendorId }));
    onClose();
  };

  return (
    <div>
      <Grid container className={classes.header} justify="space-between">
        <Grid>
          <Button onClick={onClose} size="small">
            <CloseIcon className={classes.buttonIcon} />
            Close
          </Button>
        </Grid>
      </Grid>

      <Divider />

      <Grid
        direction="row"
        alignItems="flex-start"
        container
        justify="space-between"
        className={classes.content}
      >
        <Grid item>
          <Typography component="h1" variant="h3">
            {`${vendor?.property_name}`}
          </Typography>
        </Grid>

        <Grid
          xs
          item
          alignItems="center"
          className={classes.header}
          container
          justify="flex-end"
          spacing={2}
        >
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={handleEditProperty}
            >
              Edit Property
            </Button>
          </Grid>
        </Grid>
      </Grid>

      <CustomTabs tabs={tabs} defaultTabIndex={0} />
    </div>
  );
};

export default PropertyInfo;
